/* A/B test (Convert): personalized PDP mobile sticky bar — see snippets/personalized-sticky-bar.liquid */
(function () {
  var bar = document.querySelector('[data-trc-sb]');
  if (!bar) return;
  var html = document.documentElement;
  // QA without Convert: ?sticky_bar=1
  if (/[?&]sticky_bar=1\b/.test(location.search)) html.classList.add('trc-sticky-bar');
  var prog = bar.querySelector('[data-trc-sb-progress]');
  var pLabel = bar.querySelector('[data-trc-sb-label]');
  var pHint = bar.querySelector('[data-trc-sb-hint]');
  var pFill = bar.querySelector('[data-trc-sb-fill]');
  var btnPreview = bar.querySelector('[data-trc-sb-preview]');
  var btnAtc = bar.querySelector('[data-trc-sb-atc]');

  function isVariant() { return html.classList.contains('trc-sticky-bar'); }
  function sdkPreview() { return document.querySelector('#personalized-form .btn-preview'); }
  function sdkAtc() { return document.querySelector('#personalized-form .btn-add-to-cart'); }
  function track(action) {
    try { ga('send', 'event', 'Sticky Bar', action, 'personalized'); } catch (e) {}
  }

  /* ---- Buttons proxy the SDK's real Preview / Add to cart ---- */
  btnPreview.addEventListener('click', function () {
    track('Clicked Preview');
    var b = sdkPreview(); if (b) b.click();
  });
  btnAtc.addEventListener('click', function () {
    track('Clicked Add To Cart');
    var b = sdkAtc(); if (b) b.click();
  });
  prog.addEventListener('click', function () {
    // Complete: nothing left to fill — the Preview button sits right below.
    if (prog.getAttribute('data-state') === 'complete') return;
    track('Clicked Progress Next Field');
    if (window.ctasdk && typeof window.ctasdk.focusFirstEmpty === 'function') window.ctasdk.focusFirstEmpty();
  });

  /* ---- Progress: pull from ctasdk.getProgress() on SDK form changes ---- */
  var _renderTimer = null;
  function render() {
    if (!isVariant()) return;
    var d = window.ctasdk && typeof window.ctasdk.getProgress === 'function' ? window.ctasdk.getProgress() : null;
    if (!d) return;
    var pct = typeof d.percent === 'number' ? d.percent : 0;
    var hasCount = typeof d.total === 'number' && typeof d.filled === 'number';
    // "6 of 7", not "6/7" — US shoppers read 6/7 as a date.
    var count = hasCount ? d.filled + ' of ' + d.total : pct + '%';
    pFill.style.transform = 'scaleX(' + (pct / 100) + ')';
    if (d.isComplete) {
      prog.setAttribute('data-state', 'complete');
      pLabel.textContent = '✓ All set';
      pHint.textContent = '';
    } else if (pct > 0) {
      prog.setAttribute('data-state', 'progress');
      pLabel.textContent = count;
      pHint.textContent = hasCount ? (d.total - d.filled) + ' left ›' : 'Next field ›';
    } else {
      prog.setAttribute('data-state', 'empty');
      pLabel.textContent = count;
      pHint.textContent = 'Start ›';
    }
  }
  function scheduleRender() {
    if (_renderTimer) return;
    _renderTimer = setTimeout(function () { _renderTimer = null; render(); }, 120);
  }
  document.addEventListener('artworkFormReady', scheduleRender);
  document.addEventListener('formValueChanged', scheduleRender);
  // Convert may add the variant class after the form is ready — render as soon as it lands.
  if ('MutationObserver' in window && !isVariant()) {
    var _classObs = new MutationObserver(function () {
      if (isVariant()) { _classObs.disconnect(); render(); }
    });
    _classObs.observe(html, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---- Mirror the SDK ATC's loading state; observe it to toggle the bar ---- */
  function arm() {
    var atc = sdkAtc();
    if (!atc || atc._trcSbArmed) return !!atc;
    atc._trcSbArmed = true;
    if ('MutationObserver' in window) {
      var sync = function () { btnAtc.classList.toggle('is-loading', !!atc.disabled); };
      new MutationObserver(sync).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
      sync();
      // Template switches re-render fields without a value change — recount on DOM changes.
      var form = document.getElementById('personalized-form');
      if (form) new MutationObserver(function () { if (isVariant()) scheduleRender(); })
        .observe(form, { childList: true, subtree: true });
    }
    // Show the bar while the SDK ATC is out of view (same as v4), with hysteresis: as a scroll
    // settles iOS Safari's toolbar resizes the viewport by ~80px, which flipped a single
    // in-view edge test back and forth (bar flicker) when the ATC sat near the bottom edge.
    // Show only once the ATC has fully left the viewport; hide only once it is fully clear
    // of the bar (bottom) or of the top edge.
    var shown = null, ticking = false;
    function setShown(on) {
      if (on === shown) return;
      shown = on;
      bar.classList.toggle('is-visible', on);
      html.classList.toggle('trc-sb-shown', on);
      if (on) render();
    }
    // Freshchat launcher is hidden while the personalization form is on screen (CSS), shown again
    // once it has scrolled past. Same hysteresis idea: enter when >90px of it is visible, leave
    // only when it has fully left — wider than the ~80px iOS toolbar resize.
    var formIn = false;
    function checkForm(vh) {
      var f = form && form.getBoundingClientRect();
      if (!f || !f.height) return;
      var on = formIn ? (f.top < vh && f.bottom > 0) : (f.top < vh - 90 && f.bottom > 90);
      if (on !== formIn) { formIn = on; html.classList.toggle('trc-sb-form-in-view', on); }
    }
    function check() {
      ticking = false;
      var r = atc.getBoundingClientRect(), vh = window.innerHeight;
      checkForm(vh);
      if (!r.height) return; // ATC not rendered (form re-render) — keep the current state
      if (shown) {
        // Bar height for lifting the Freshchat launcher above it (see CSS); changes with the safe area.
        var h = bar.offsetHeight;
        if (h && h + 'px' !== html.style.getPropertyValue('--trc-sb-h')) html.style.setProperty('--trc-sb-h', h + 'px');
        if (r.top >= 0 && r.bottom <= vh - h) setShown(false);
      } else if (shown === false) {
        if (r.top >= vh || r.bottom <= 0) setShown(true);
      } else {
        setShown(r.top >= vh || r.bottom <= 0);
        if (shown) check();
      }
    }
    function queueCheck() {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }
    window.addEventListener('scroll', queueCheck, { passive: true });
    window.addEventListener('resize', queueCheck);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', queueCheck);
    // Back from /cart (bfcache) or a form re-render can move the ATC without a scroll.
    window.addEventListener('pageshow', queueCheck);
    if ('MutationObserver' in window && form) new MutationObserver(queueCheck).observe(form, { childList: true, subtree: true });
    check();
    render();
    return true;
  }
  document.addEventListener('customall-script-injected', function () { setTimeout(arm, 500); });
  var _armTries = 0, _armTimer = setInterval(function () {
    if (arm() || ++_armTries > 40) clearInterval(_armTimer);
  }, 500);

  /* ---- Guard the success → /cart redirect gap: the SDK re-enables its button just before it
     navigates to /cart, which would briefly re-arm the sticky ATC (a second add). A successful
     /cart/add means the redirect is imminent, so keep the sticky ATC locked until the page leaves. ---- */
  (function () {
    function commit() { btnAtc.classList.add('is-committing'); }
    function isAdd(u) { return String(u || '').indexOf('/cart/add') > -1; }
    var _fetch = window.fetch;
    if (_fetch) window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0];
      var p = _fetch.apply(this, arguments);
      if (isAdd(url)) p.then(function (r) { if (r && r.ok) commit(); }).catch(function () {});
      return p;
    };
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (isAdd(url)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) commit(); });
      return _open.apply(this, arguments);
    };
    // Back from /cart: Safari restores the page from bfcache with the lock still on — release it
    // and re-sync the loading state from the SDK button.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      btnAtc.classList.remove('is-committing');
      var atc = sdkAtc();
      btnAtc.classList.toggle('is-loading', !!(atc && atc.disabled));
    });
  })();
})();
